import { Injectable } from '@angular/core';
import { PathHelper } from 'src/app/helpers/path.helper';
import { UrlHelper } from 'src/app/helpers/url.helper';

@Injectable({
  providedIn: 'root'
})
export class IconsService {
  private iconSet: any = {};

  constructor() {
    this.load();
  }

  getIconByFormat(format: string) {
    if (format.includes(".")) {
      format = PathHelper.getExtension(format);
    }

    format = format.trim().toLowerCase();

    switch (format) {
      case "doc":
      case "docx":
        return "file-word";
      case "txt":
        return "notepad";
      case "pdf":
        return "file-pdf";
      default:
        return "file";
    }
  }

  getIcon(name: string): string {
    if (name && name.includes("://")) {
      return name;
    }

    if (!this.iconSet.icons[name]) {
      return null;
    }

    return UrlHelper.join(this.iconSet.base, this.iconSet.icons[name]);
  }

  async load() {
    const response = await fetch("/assets/os/icons/default-icons.json");
    this.iconSet = await response.json();
  }
}
